import initServices from ".";

const { useFetch, usePost } = initServices();

export const useCreateCustomer = ({campaignId}: any): [[data: any , error: any], (variables?: any) => void, boolean] => {
  const [resp, createFn, loading] = usePost(`/sales/isi-pilot/chats/${campaignId}/`);

  return [resp, createFn, loading];
}

export const useFetchCustomer = ({campaignId}: any): [[data: any , error: any], (variables?: any) => void, boolean] => {
  const [resp, fetchFn, loading] = useFetch(`/sales/isi-pilot/chats/${campaignId}`);

  return [resp, fetchFn, loading];
}

export const useDeleteCustomer = ({campaignId}: any): [[data: any , error: any], (variables?: any) => void, boolean] => {
  const [resp, deleteFn, loading] = useFetch(`/sales/isi-pilot/chats/${campaignId}`);

  return [resp, deleteFn, loading];
}